import { NavigationTabs, TabProps } from '@/ui/shared/navigation-tabs'
import { useRegisterChatContext } from '@/ui/components/ai-chat'
import {
  ReturnRateByMonth,
  ReturnRateByCountry
} from '@/ui/components/return-rates'
import { useTranslation } from 'react-i18next'
import moment from 'moment'
import { AnalyticsFilterBar } from '@/ui/components/analytics-filters'
import { ReturnRateByMonthArea } from '@/ui/components/return-rates/return-rate-by-month-area'

function ReturnsAnalytics() {
  const { t } = useTranslation()

  useRegisterChatContext({
    tab: 'analytics',
    getPayload: () => ({ current_tab: 'analytics' })
  })

  const tabs: TabProps[] = [
    {
      link: '/analytics/compensation',
      copy: t('product_analytics.return_amount')
    },
    {
      link: '/analytics/return-rates',
      copy: t('product_analytics.return_rate')
    }
  ]

  const startDate = moment()
    .subtract(12, 'M')
    .startOf('month')
    .format('YYYY-MM-DD')

  const endDate = moment().subtract(1, 'M').endOf('month').format('YYYY-MM-DD')

  return (
    <div className="relative">
      <div className="sticky top-0 z-10">
        <NavigationTabs tabs={tabs} selectedIndex={1} />
      </div>
      <div className="flex size-full flex-col items-center">
        <div className="flex w-full flex-col items-center gap-6 p-4">
          <AnalyticsFilterBar
            startDate={startDate}
            endDate={endDate}
            className="justify-start self-start"
          />
          <div className="flex w-full flex-wrap gap-4">
            <ReturnRateByMonthArea />
            <ReturnRateByMonth />
          </div>
          <ReturnRateByCountry />
        </div>
      </div>
    </div>
  )
}

export default ReturnsAnalytics
